import { ProdOrderCommandResult } from './prod-order-command'

export class ProdOrderCommandDialogResponse {
  public static ignore() {
    return new ProdOrderCommandDialogResponse(null, null)
  }

  public static failed(err?: any) {
    return new ProdOrderCommandDialogResponse(null, err)
  }

  public static of(result: ProdOrderCommandResult): ProdOrderCommandDialogResponse {
    return new ProdOrderCommandDialogResponse(result)
  }

  constructor(
    public readonly result: ProdOrderCommandResult,
    public readonly error?: any
  ) {}
}
